import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromRoot from 'app/core/store/reducers';
import * as fromLoaderSelectors from 'app/core/store/selectors/loader.selectors';

@Component({
  standalone: false,
  selector: 'pptl-loader',
  templateUrl: 'loader.component.html',
  styleUrls: ['loader.component.scss'],
})
export class LoaderComponent {
  loading$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>) {
    this.loading$ = this.store.pipe(select(fromLoaderSelectors.getIsLoading));
  }
}
